import { IChatProvider, IConfiguration } from '@enuan/chat__utils';
import { ReduxProvider } from 'src/reduxStore/reduxProvider';
import { InstanceProvider } from './contexts/instance/InstanceProvider';
import { ConfigProvider } from './contexts/config/Provider';
import { ThemeWrapper } from 'src/theme/ThemeWrapper';
import { ErrorBoundary } from 'src/components/ErrorBoundary/ErrorBoundary';
import { IntlProvider } from './contexts/Intl.provider';
import {
	FrameStateProvider,
	IFrameStateProviderProps,
} from './contexts/frame/Provider';
import { NotificationProvider } from './contexts/notification.provider';
import {
	ChatInitProvider,
	IChatInitProviderProps,
} from './contexts/ChatInit.provider';

export type IAppProviderProps = {
	instance: IChatProvider;
	configuration: IConfiguration;
	apiProps?: IChatInitProviderProps & IFrameStateProviderProps;
	baseUrl: string;
};
export const AppProvider = ({
	children,
	configuration,
	apiProps,
	instance,
	baseUrl,
}: React.PropsWithChildren<IAppProviderProps>) => {
	const { onConnection, onWebMessage, params, ...frameProps } = apiProps || {};
	return (
		<ReduxProvider>
			<InstanceProvider
				instance={instance}
				configuration={configuration}
				baseUrl={baseUrl}
			>
				<ConfigProvider baseUrl={baseUrl}>
					<FrameStateProvider {...frameProps}>
						<ThemeWrapper>
							<ErrorBoundary id="app" FallbackRender={() => null}>
								<IntlProvider>
									<NotificationProvider>
										<ChatInitProvider
											onConnection={onConnection}
											onWebMessage={onWebMessage}
											params={params}
										>
											{children}
										</ChatInitProvider>
									</NotificationProvider>
								</IntlProvider>
							</ErrorBoundary>
						</ThemeWrapper>
					</FrameStateProvider>
				</ConfigProvider>
			</InstanceProvider>
		</ReduxProvider>
	);
};
